import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 4.001 19.5 4l-.116.007A1 1 0 0 0 18.5 5l.007.116A1 1 0 0 0 19.5 6h5.085l-7.296 7.297-.083.094a1 1 0 0 0 1.497 1.32L26 7.414 26 12.5l.007.117A1 1 0 0 0 28 12.5L27.999 5l-.007-.116A1 1 0 0 0 27 4.001M15 9a1 1 0 0 0-1-1H6l-.15.005A2 2 0 0 0 4 10v16l.005.15A2 2 0 0 0 6 28h16l.15-.006A2 2 0 0 0 24 26v-8l-.007-.117A1 1 0 0 0 22 18v8H6V10h8l.117-.007A1 1 0 0 0 15 9"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconArrowSquareOut = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowSquareOut);
export default Memo;
